import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQ_ITEMS = [
    {
        q: 'Wat kost een douchelezer?',
        a: 'Leasen kan vanaf \u20ac39 per maand per terminal, inclusief software en beveiligde internetverbinding. Kopen kan ook; de investering verdient zich terug afhankelijk van uw bezetting en het tarief per douchebeurt. Gebruik de calculator bovenaan deze pagina voor een berekening op basis van uw eigen cijfers.',
    },
    {
        q: 'Kan ik het tarief per douchebeurt zelf instellen?',
        a: 'Ja. Via het online portal bepaalt u zelf het bedrag per douchebeurt en de douchetijd. Aanpassen kan op elk moment, bijvoorbeeld voor hoog- en laagseizoen. Wijzigingen zijn direct actief op de terminal.',
    },
    {
        q: 'Werkt de terminal ook op bestaande doucheruimtes?',
        a: 'Ja. De douchelezer is geschikt voor zowel nieuwe als bestaande doucheruimtes. Wij leveren de hardware, software en beveiligde internetverbinding als compleet pakket, zodat de installatie zonder grote verbouwing kan.',
    },
    {
        q: 'Welke betaalmethoden accepteert de douchelezer?',
        a: 'De Adyen S1U2 accepteert pinpassen, creditcards en mobiele wallets zoals Apple Pay en Google Pay. Gasten hebben dus geen muntjes, sleutels of aparte pasjes meer nodig.',
    },
    {
        q: 'Hoe snel is de installatie geregeld?',
        a: 'Na uw akkoord leveren wij de terminals compleet geconfigureerd. De installatie per doucheruimte is doorgaans binnen een dag gereed. Neem contact op voor een planning op maat voor uw locatie.',
    },
];

function slugify(text) {
    return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}

function FaqItem({ question, answer, initialOpen = false }) {
    const [open, setOpen] = useState(initialOpen);
    const id = slugify(question);
    return (
        <div className="border-b border-[#3D3B00]/10 last:border-0" data-testid={`faq-item-${id}`}>
            <button
                onClick={() => setOpen(!open)}
                className="w-full flex items-start justify-between gap-4 py-5 text-left group"
                aria-expanded={open}
                data-testid={`faq-toggle-${id}`}
            >
                <h3 className="text-lg font-semibold text-[#3D3B00] group-hover:text-[#4CAF50] transition-colors m-0">
                    {question}
                </h3>
                <ChevronDown className={`w-5 h-5 text-[#3D3B00]/40 flex-shrink-0 mt-1 transition-transform ${open ? 'rotate-180' : ''}`} />
            </button>
            {/* Answer is always in DOM (for SEO), visibility controlled by CSS */}
            <div
                className={`overflow-hidden transition-all ${open ? 'max-h-96 pb-5' : 'max-h-0'}`}
                data-testid={`faq-answer-${id}`}
            >
                <p className="text-[#3D3B00]/75 leading-relaxed m-0">{answer}</p>
            </div>
        </div>
    );
}

export function FaqSection() {
    return (
        <section className="py-16 lg:py-24 px-4 bg-[#FBF7EE]" data-testid="faq-section">
            <div className="max-w-3xl mx-auto">
                <h2 className="text-3xl sm:text-4xl font-bold text-[#3D3B00] font-['Outfit'] mb-8 tracking-tight">
                    Veelgestelde vragen
                </h2>
                <div className="bg-white/80 rounded-2xl shadow-lg border border-[#3D3B00]/10 px-6 lg:px-8">
                    {FAQ_ITEMS.map((item) => (
                        <FaqItem key={item.q} question={item.q} answer={item.a} />
                    ))}
                </div>
            </div>
        </section>
    );
}
